'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import type { JSX } from 'react';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';
import { PipelineStepRejectedBadge } from '../pipeline-step-rejected-badge';

interface IRejectedChallengeStepProps {
  item: ICollectionPipelineStatusV3;
}

export function RejectedChallengeStep({ item }: IRejectedChallengeStepProps): JSX.Element {
  const { clipsRejected } = item.steps;

  return (
    <PipelineStepCell
      badge={<PipelineStepRejectedBadge count={clipsRejected.challenge} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Rejected challenges"
          description={`${clipsRejected.challenge} challenge(s) fully rejected. Already excluded from the Populate / Translated / Cropped / Uploaded / Published totals via the active-status filter, listed here for visibility.`}
          dataHref={`/sys/challenges?collectionId=${item.collectionId}&triageStatus=rejected`}
          dataLabel="Open rejected challenges"
        />
      )}
    />
  );
}
